<template>
	<div class="tcContent">
		<div class="rowCard tRowCard">

			<div class="calCard">
				<div class="card">
					<i></i> <i></i> <i></i> <i></i>
					<div class="cardTitle">
						<span>总用电量分析</span>
						<p>单位：千瓦时（kw · h）</p>
					</div>
					<div class="echart" id="electricity" ref="electricity"></div>
				</div>
			</div>
			<div class="calCard">
				<div class="card">
					<i></i> <i></i> <i></i> <i></i>
					<div class="cardTitle">
						<span>总用水量分析</span>
						<p>单位：吨（t）</p>
					</div>
					<div class="echart" id="electricity2" ref="electricity2"></div>
				</div>
			</div>
			<div class="calCard">
				<div class="card">
					<i></i> <i></i> <i></i> <i></i>
					<div class="cardTitle">
						<span>天然气锅炉房使用情况</span>
						<p>单位：升（L）</p>
					</div>
					<div class="echart" id="water" ref="water"></div>
				</div>
			</div>

		</div>
		<div class="rowCard">

			<div class="calCard">
				<div class="card">
					<i></i> <i></i> <i></i> <i></i>
					<div class="cardTitle">
						<span>首发项目客户用电</span>
						<p>单位：千瓦时（kw · h）</p>
					</div>
					<div class="echartK">
						<div class="echart" id="userElectricity" ref="userElectricity"></div>
						<div class="echart" id="userElectricity2" ref="userElectricity2"></div>
					</div>
				</div>
			</div>
			<div class="calCard">
				<div class="card">
					<i></i> <i></i> <i></i> <i></i>
					<div class="cardTitle">
						<span>首发项目客户生活用水</span>
						<p>单位：吨（t）</p>
					</div>
					<div class="echart" id="userWater" ref="userWater"></div>

					<div class="echartK">
						<div class="echart" id="userWater" ref="userWater"></div>
						<div class="echart" id="userWater2" ref="userWater2"></div>
					</div>
				</div>

			</div>

		</div>
		<div class="rowCard bCard">
			<div class="rowCard bCard">
				<div class="calCard">
					<div class="card">
						<i></i> <i></i> <i></i> <i></i>
						<div class="cardTitle">
							<span>首发项目公共用电（2025年）</span>
							<p>单位：千瓦时（kw·h）</p>
						</div>
						<div class="echart" id="bChart1" ref="bChart1"></div>
					</div>
					<div class="card" style="flex: 1;">
						<i></i> <i></i> <i></i> <i></i>
						<div class="cardTitle">
							<div class="cardTitleInner">
								<img src="@/assets/fx.png" alt="" srcset="" />
								<span>用电数据分析</span>
							</div>
						</div>
						<div class="fpView">
							<div class="fpViewItem">
								<span>当日用电总量（kw）</span>
								<div class="b">
									<div class="l">
										<div><span>0</span></div>
										<div><span>0</span></div>
										<div><span>0</span></div>
										<div><span>2</span></div>
										<div><span>3</span></div>
									</div>
									<p>
										同比增长
										<span>11.3% ▲</span>
									</p>
								</div>
							</div>
							<div class="fpViewItem">
								<span>当月用电总量（kw）</span>
								<div class="b">
									<div class="l">
										<div><span>0</span></div>
										<div><span>0</span></div>
										<div><span>1</span></div>
										<div><span>8</span></div>
										<div><span>5</span></div>
									</div>
									<p>
										同比增长
										<span>28.9% ▲</span>
									</p>
								</div>
							</div>
							<div class="fpViewItem">
								<span>当年用电总量（kw）</span>
								<div class="b">
									<div class="l">
										<div><span>3</span></div>
										<div><span>8</span></div>
										<div><span>2</span></div>
										<div><span>4</span></div>
										<div><span>3</span></div>
									</div>
									<p>
										同比增长
										<span>32.9% ▲</span>
									</p>
								</div>
							</div>
					
						</div>
					</div>
				</div>
				<div class="calCard">
					<div class="card" style="flex: 1;">
						<i></i> <i></i> <i></i> <i></i>
						<div class="cardTitle">
							<span>首发项目公共用水（2025年）</span>
							<p>单位：吨（t）</p>
						</div>
						<div class="echart" id="bChart2" ref="bChart2"></div>
					</div>
					<div class="card" style="flex: 1;">
						<i></i> <i></i> <i></i> <i></i>
						<div class="cardTitle">
							<div class="cardTitleInner">
								<img src="@/assets/fx.png" alt="" srcset="" />
								<span>用水数据分析</span>
							</div>
						</div>
						<div class="fpView">
							<div class="fpViewItem">
								<span>当日用水总量（t）</span>
								<div class="b">
									<div class="l">
										<div><span>0</span></div>
										<div><span>0</span></div>
										<div><span>1</span></div>
										<div><span>3</span></div>
										<div><span>1</span></div>
									</div>
									<p>
										同比增长
										<span>11.4% ▲</span>
									</p>
								</div>
							</div>
							<div class="fpViewItem">
								<span>当月用水总量（t）</span>
								<div class="b">
									<div class="l">
										<div><span>0</span></div>
										<div><span>1</span></div>
										<div><span>5</span></div>
										<div><span>6</span></div>
										<div><span>7</span></div>
									</div>
									<p>
										同比增长
										<span>19.8% ▲</span>
									</p>
								</div>
							</div>
							<div class="fpViewItem">
								<span>当年用水总量（t）</span>
								<div class="b">
									<div class="l">
										<div><span>3</span></div>
										<div><span>9</span></div>
										<div><span>6</span></div>
										<div><span>4</span></div>
										<div><span>1</span></div>
									</div>
									<p>
										同比增长
										<span>28.9% ▲</span>
									</p>
								</div>
							</div>

						</div>
					</div>
				</div>
				<div class="calCard">
					<div class="card" style="padding-bottom: 10px;">
						<i></i> <i></i> <i></i> <i></i>
						<div class="cardTitle" style="width: 100%;flex-direction: row;justify-content: space-between;">
							<span>能源中心</span>
							<div>单位：月</div>
						</div>
						<!-- <div class="echart" id="bChart2" ref="bChart2"></div> -->
						<div class="nhzx">
							<div class="top">
								<div class="item ">
									<p>82.kw·h</p>
									<div class="anim y">
										<img src="@/assets/index/blY.png" alt="" />
										<div class="animInner y">
											<img src="@/assets/index/blY.png" alt="" />
										</div>
									</div>
									<div class="label">电</div>
									<img src="@/assets/index/1.png" class="b" alt="" />
								</div>
								<div class="item">
									<p>142t</p>
									<div class="anim g">
										<img src="@/assets/index/blG.png" alt="" />
										<div class="animInner g">
											<img src="@/assets/index/blG.png" alt="" />
										</div>
									</div>
									<div class="label">水</div>
									<img src="@/assets/index/2.png" class="b" alt="" />
								</div>
								<div class="item">
									<p>566N㎡</p>
									<div class="anim b1">
										<img src="@/assets/index/blB1.png" alt="" />
										<div class="animInner b1">
											<img src="@/assets/index/blB1.png" alt="" />
										</div>
									</div>
									<div class="label">气</div>
									<img src="@/assets/index/3.png" class="b" alt="" />
								</div>
								<div class="item">
									<span>363</span>
									<div class="anim b2">
										<img src="@/assets/index/blB2.png" alt="" />
										<div class="animInner b2">
											<img src="@/assets/index/blB2.png" alt="" />
										</div>
									</div>
									<div class="label">综合能耗</div>
									<img src="@/assets/index/4.png" class="b" alt="" />
								</div>
								<div class="item">
									<span>612</span>
									<div class="anim b3">
										<img src="@/assets/index/blB3.png" alt="" />
										<div class="animInner b3">
											<img src="@/assets/index/blB3.png" alt="" />
										</div>
									</div>
									<div class="label">
										<p>碳排放量</p>
										<p>单位：年</p>
									</div>
									<img src="@/assets/index/5.png" class="b" alt="" />
								</div>
							</div>
							<div class="bottom">
								<div class="itemK">
									<div class="values">
										<div>
											<span>7-2园区</span>
											<span>53.3kw·h</span>
										</div>
										<div>
											<span>7-5园区</span>
											<span>28.7kw·h</span>
										</div>
									</div>
									<div class="item" ref="bChart3"></div>
									<span class="inner">分项用电</span>
								</div>
								<div class="itemK">
									<div class="values">
										<div>
											<span>7-2园区</span>
											<span>61.06t</span>
										</div>
										<div>
											<span>7-5园区</span>
											<span>80.94t</span>
										</div>
									</div>
									<div class="item" ref="bChart4"></div>
									<span class="inner">分项用水</span>
								</div>
								<div class="itemK">
									<div class="values">
										<div>
											<span>7-2园区</span>
											<span>215.08N㎡</span>
										</div>
										<div>
											<span>7-5园区</span>
											<span>350.92N㎡</span>
										</div>
									</div>
									<div class="item" ref="bChart5"></div>
									<span class="inner">分项用气</span>
								</div>
								<!-- <div class="item progress">
									<div class="title">
										<p>综合能耗</p>
										<p>碳排放量</p>
									</div>
									<div class="progressList">
										<div class="progressItem" v-for="(item,index) in progress" :key="index">
											<span>{{item.title}}: {{item.value}}%</span>
											<div class="progressInner">
												<div class="progressView" :style="{width: item.value + '%',background: item.color}"></div>
											</div>
										</div>
									</div>
								</div> -->
							</div>
						</div>
					</div>
				</div>

			</div>

		</div>
	</div>
</template>

<script>
	import {
		electricityOption,
		electricityOption2,
		publicWaterOption,
		userElectricityOption,
		userElectricityOption2,
		userWaterOption,
		userWaterOption2,
		chart1,
		chart2,
		chart3,
		chart4,
		chart5,
	} from '../common/indexOptions.js';
	import * as echarts from 'echarts';
	export default {
		name: 'HelloWorld',
		data() {
			return {
				electricity: null,
				electricity2: null,
				water: null,
				userElectricity: null,
				userElectricity2: null,
				userWater: null,
				userWater2: null,
				chart1: null,
				chart2: null,
				chart3: null,
				chart4: null,
				chart5: null,

				progress: [{
					title: '办公用电',
					value: 32.98,
					color: '#f36565'
				}, {
					title: '电梯',
					value: 3.93,
					color: '#2969ff'
				}, {
					title: '照明',
					value: 46.35,
					color: '#3dd3ea'
				}, {
					title: '其他',
					value: 0.97,
					color: '#59dd9d'
				}, {
					title: '备用',
					value: 13.93,
					color: '#ff972f'
				}, {
					title: '风机',
					value: 1.84,
					color: '#339bfd'
				}]
			}
		},
		created: function() {
			this.$nextTick(_ => {
				this.setChart();
			})
			let _self = this;
			window.addEventListener('resize', function() {
				clearTimeout(_self.timer)
				_self.timer = setTimeout(_ => {
					_self.resize()
				}, 1000)
			})
		},
		methods: {
			resize() {
				this.electricity.resize();
				this.electricity2.resize();
				this.water.resize();
				this.userElectricity.resize();
				this.userElectricity2.resize();
				this.userWater.resize();
				this.userWater2.resize();
				this.chart1.resize();
				this.chart2.resize();
				this.chart3.resize();
				this.chart4.resize();
				this.chart5.resize();
				this.chart6.resize();
			},
			setChart() {
				this.$nextTick(_ => {
					this.electricity = echarts.init(this.$refs.electricity, null, {devicePixelRatio: 2.5});
					this.electricity.setOption(electricityOption);

					this.electricity2 = echarts.init(this.$refs.electricity2, null, {devicePixelRatio: 2.5});
					this.electricity2.setOption(electricityOption2);

					this.water = echarts.init(this.$refs.water, null, {devicePixelRatio: 2.5});
					this.water.setOption(publicWaterOption);

					this.userElectricity = echarts.init(this.$refs.userElectricity, null, {devicePixelRatio: 2.5});
					this.userElectricity.setOption(userElectricityOption);

					this.userElectricity2 = echarts.init(this.$refs.userElectricity2, null, {devicePixelRatio: 2.5});
					this.userElectricity2.setOption(userElectricityOption2);

					this.userWater = echarts.init(this.$refs.userWater, null, {devicePixelRatio: 2.5});
					this.userWater.setOption(userWaterOption);

					this.userWater2 = echarts.init(this.$refs.userWater2, null, {devicePixelRatio: 2.5});
					this.userWater2.setOption(userWaterOption2);

					this.chart1 = echarts.init(this.$refs.bChart1, null, {devicePixelRatio: 2.5});
					this.chart1.setOption(chart1);

					this.chart2 = echarts.init(this.$refs.bChart2, null, {devicePixelRatio: 2.5});
					this.chart2.setOption(chart2);

					this.chart3 = echarts.init(this.$refs.bChart3, null, {devicePixelRatio: 2.5});
					this.chart3.setOption(chart3);

					this.chart4 = echarts.init(this.$refs.bChart4, null, {devicePixelRatio: 2.5});
					this.chart4.setOption(chart4);

					this.chart5 = echarts.init(this.$refs.bChart5, null, {devicePixelRatio: 2.5});
					this.chart5.setOption(chart5);
				})
			}

		}
	}
</script>

<style scoped lang="scss">
	div {
		font-size: 12px;
		line-height: 1.8;
		/* #ifndef APP */
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-webkit-flex-direction: column;
		-ms-flex-direction: column;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		/* #endif */
		display: flex;
		flex-direction: column;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}

	.tRowCard {
		.calCard {
			margin: 0 10px;

			&:first-child {
				margin-left: 0;
			}

			&:last-child {
				margin-right: 0;
			}
		}
	}

	.tcContent {
		padding: 24px 20px;
		flex: 1;
		max-height: 100vh;
		overflow: hidden;
	}

	.rowCard {
		flex-direction: row;
		justify-content: space-between;
		align-items: stretch;
		flex: 1;
		padding-bottom: 20px;
	}

	.rowCard:last-child {
		padding-bottom: 0;
	}

	.calCard {
		width: calc(50% - 15px);
		height: 100%;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}

	.card {
		flex: 1;
		height: 100%;
		border: 1px solid rgba(32, 110, 212, .5);
		background: rgba(32, 110, 212, .1);
		position: relative;
		transition: all .2s;
	}

	.card:hover {
		background: rgba(32, 110, 212, .3);
	}

	.numList {
		max-width: 40% !important;
		min-width: 320px;
		margin-right: -2px;
		z-index: 2;
	}


	.card i {
		display: block;
		position: absolute;
	}

	.card i:first-child {
		top: 0;
		left: 0;
		position: absolute;
	}

	.card i:first-child:before {
		content: '';
		display: block;
		width: 9px;
		height: 2px;
		background: #206ED4;
		position: absolute;
		top: 0;
		left: 0;
	}

	.card i:first-child::after {
		content: '';
		display: block;
		width: 2px;
		height: 9px;
		background: #206ED4;
		position: absolute;
		top: 0;
		left: 0;
	}

	.card i:nth-child(2) {
		top: 0;
		right: 9px;
		position: absolute;
	}

	.card i:nth-child(2):before {
		content: '';
		display: block;
		width: 9px;
		height: 2px;
		background: #206ED4;
		position: absolute;
		top: 0;
		left: 0;
	}

	.card i:nth-child(2)::after {
		content: '';
		display: block;
		width: 2px;
		height: 9px;
		background: #206ED4;
		position: absolute;
		top: 0;
		right: -9px;
	}

	.card i:nth-child(3) {
		bottom: 9px;
		left: 0;
		position: absolute;
	}

	.card i:nth-child(3):before {
		content: '';
		display: block;
		width: 9px;
		height: 2px;
		background: #206ED4;
		position: absolute;
		top: 7px;
		left: 0;
	}

	.card i:nth-child(3)::after {
		content: '';
		display: block;
		width: 2px;
		height: 9px;
		background: #206ED4;
		position: absolute;
		top: 0;
		left: 0;
	}

	.card i:nth-child(4) {
		bottom: 9px;
		right: 9px;
		position: absolute;
	}

	.card i:nth-child(4):before {
		content: '';
		display: block;
		width: 9px;
		height: 2px;
		background: #206ED4;
		position: absolute;
		top: 7px;
		left: 0;
	}

	.card i:nth-child(4)::after {
		content: '';
		display: block;
		width: 2px;
		height: 9px;
		background: #206ED4;
		position: absolute;
		top: 0;
		left: 7px;
	}

	.echart {
		width: 100%;
		flex: 1;
	}


	.viewList {
		flex: 1;
		padding: 0 8px 8px;
	}

	.viewListTh {
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 30px;
		background: #113F73;
	}

	.viewListTd {
		flex: 1;
		padding: 0 10px;
		color: #07DBFF;
		white-space: nowrap;

	}

	.viewListTd:nth-child(2) {
		justify-content: center;
		align-items: center;
	}

	.viewListTd:last-child {
		align-items: flex-end;
	}

	.viewListTr .viewListTd {
		color: #CCC;
	}

	.viewListTr .viewListTd:first-child {
		color: #FFF;
	}

	.viewListTr {
		border: 1px solid transparent;
		border-bottom: 1px solid #09718F;
		padding-right: 10px;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		height: 30px;
		position: relative;
	}

	.viewListTr:hover {
		border: 1px solid #07DBFF;
		box-shadow: 0 0 10px 0 #07DBFF inset;
	}

	.viewListTr:hover::after {
		content: '';
		display: block;
		border-top: 4px solid transparent;
		border-right: 6px solid #07DBFF;
		border-bottom: 4px solid transparent;
		border-left: 4px solid transparent;
		position: absolute;
		right: 6px;
	}


	.viewListTitle {
		font-size: 14px;
		color: #FFF;
		justify-content: center;
		align-items: center;
		height: 36px;
		min-height: 36px;
		letter-spacing: 3px;
		background: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 20%, #043D85 36%, #043D85 64%, rgba(0, 0, 0, 0) 80%, rgba(0, 0, 0, 0) 100%);
	}

	.viewListTitle::after {
		content: '';
		display: flex;
		width: 70%;
		height: 2px;
		background: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 20%, #31b7ff 30%, #FFF 50%, #31b7ff 70%, rgba(0, 0, 0, 0) 80%, rgba(0, 0, 0, 0) 100%);
	}


	.cardTitle {
		padding: 10px;
		position: absolute;
	}

	.cardTitle span {
		color: #FFF;
		font-size: 12px;
	}

	.cardTitle p {
		color: #206ED4;
		font-size: 10px;
	}

	.cardTitleInner {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		padding-top: 6px;
	}

	.cardTitleInner img {
		width: 18px;
		height: 18px;
	}

	.cardTitleInner span {
		font-size: 10px;
		color: #FFF;
		line-height: 14px;
		border-left: 1px solid #FFF;
		margin-left: 8px;
		padding-left: 8px;
	}

	.fpView {
		padding-top: 50px;
		padding-left: 32px;
	}

	.fpViewItem {
		&>span {
			font-size: 14px;
			color: #26D1D4;
		}

		.b {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: flex-end;
			margin: 10px 0;

			.l {
				display: flex;
				flex-direction: row;
				justify-content: flex-start;
				align-items: center;
				margin-right: 8px;

				div {
					height: 38px;
					width: 28px;
					display: flex;
					justify-content: center;
					align-items: center;
					color: #FFF;
					font-size: 28px;
					font-weight: bold;
					margin-right: 4px;
					position: relative;

					span {
						z-index: 2;
					}

					&::before {
						content: '';
						display: flex;
						background: #224594;
						width: 28px;
						height: 18px;
						position: absolute;
						border-radius: 2px 2px 0 0;
						z-index: 1;
						top: 0;
					}

					&::after {
						content: '';
						display: flex;
						background: #224594;
						width: 28px;
						height: 18px;
						position: absolute;
						border-radius: 0 0 2px 2px;
						z-index: 1;
						bottom: 0;
					}
				}
			}

			p {
				color: #26D1D4;
				font-size: 12px;
				line-height: 14px;
				white-space: nowrap;

				span {
					color: #FFBA63;
					white-space: nowrap;
				}
			}
		}
	}

	.echartK {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: stretch;
		height: 100%;

		.echart {
			flex: 1;
		}

		.echart:last-child {
			max-width: 220px;
		}
	}

	.bCard .calCard {
		flex: 1;
		margin-right: 24px;
		justify-content: space-between;

		&:last-child {
			margin: 0;
		}
	}

	.chfxView {
		font-size: 8px;
		color: #08C3E6;
		padding: 36px 13px 10px;

		.t>span {
			transform: scale(.85, .85) translateX(-8px);
		}
	}

	.tList {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-end;
		margin-top: 10px;
		padding-bottom: 10px;
		border-bottom: 1px dashed #666;

		div {
			flex: 1;
			transform: scale(.85, .85);
		}

		p {
			font-size: 14px;
			color: #FFF;
		}
	}

	.chfxView {
		height: 100%;

		.b {
			display: flex;
			flex: 1;
			justify-content: space-between;
			align-items: center;

			.bb {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;

				p {
					transform: scale(.75, .75);
					white-space: nowrap;

					span {
						font-size: 16px;
						color: #FFF;
					}
				}
			}
		}
	}

	.sjfx {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		padding: 0 10px;
		flex: 1;
	}

	.sjfxImg {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100px;

		img {
			width: 72px;
			height: 56px;
		}

		.text {
			position: absolute;
			color: #FFF;
			text-align: center;

			span {
				font-size: 14px;
				line-height: 16px;
			}

			p {
				font-size: 10px;
				transform: scale(.8, .8);
			}
		}
	}

	.sjfxText {
		padding-left: 12px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		width: 100%;
	}

	.sjfxItem {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		margin-bottom: 4px;

		span {
			color: #08C3E6;
			font-size: 10px;
			transform: scale(.8, .8) translateX(-5px);
			line-height: 14px;
		}

		p {
			color: #FFF;
			font-size: 15px;
			line-height: 18px;
		}
	}

	.sjfxTextB {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		width: 100%;

		.sjfxItem {
			flex: 1;
		}

		.progress {
			width: 70px;
			height: 10px;
			background-color: #243248;
			margin-top: 6px;
			position: relative;

			div {
				height: 10px;
				background: linear-gradient(to right, #0C6FD7 0%, #62E7FE 100%);
			}

			span {
				position: absolute;
				display: flex;
				width: 100%;
				justify-content: center;
				align-items: center;
				color: #FFF;
				line-height: 10px;
			}
		}
	}

	.nhzx {
		padding: 30px 0 10px;
		flex: 1;

		.top {
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			padding-top: 10px;
			padding-right: 60px;
			padding: 20px 20px 0;

			.item {
				flex-direction: row;
				justify-content: center;
				align-items: center;
				position: relative;
				&>span {
					font-size: 12px;
					margin-right: 6px;
					margin-left: 10px;
					position: absolute;
					left: -40px;
				}
				&>p{
					position: absolute;
					top: 20px;
					font-size: 14px;
					font-weight: bold;
				}

				@keyframes blMove {
					0% {
						transform: translateX(0);
					}

					100% {
						transform: translateX(calc(100% - 100px));
					}
				}

				@keyframes blMove2 {
					0% {
						transform: translateX(calc(100% - 88px));
					}

					100% {
						transform: translateX(0);
					}
				}

				.anim {
					width: 80px;
					height: 80px;
					border-radius: 50%;
					overflow: hidden;
					position: relative;
					justify-content: center;
					align-items: center;

					>img {
						width: 186px;
						position: absolute;
						bottom: -44px;
						right: 0;
						animation: blMove 2s infinite linear;
						opacity: .5;
					}

					&.y {
						border: 1px dashed #ffec29;
					}

					&.g {
						border: 1px dashed #29ff9e;
					}

					&.b1 {
						border: 1px dashed #29fcff;
					}

					&.b2 {
						border: 1px dashed #29bcff;
					}

					&.b3 {
						border: 1px dashed #296aff;
					}

					.animInner {
						width: 60px;
						height: 60px;
						border-radius: 50%;
						position: relative;
						overflow: hidden;

						&.y {
							box-shadow: 0 0 20px 0 rgba(255, 236, 41, .8) inset;
							border: 2px solid rgba(255, 236, 41, 1);
						}

						&.g {
							box-shadow: 0 0 20px 0 rgba(41, 255, 158, .8) inset;
							border: 2px solid rgba(41, 255, 158, 1);
						}

						&.b1 {
							box-shadow: 0 0 20px 0 rgba(41, 252, 255, .8) inset;
							border: 2px solid rgba(41, 252, 255, 1);
						}

						&.b2 {
							box-shadow: 0 0 20px 0 rgba(41, 188, 255, .8) inset;
							border: 2px solid rgba(41, 188, 255, 1);
						}

						&.b3 {
							box-shadow: 0 0 20px 0 rgba(41, 106, 255, .8) inset;
							border: 2px solid rgba(41, 106, 255, 1);
						}

						>img {
							width: 166px;
							position: absolute;
							bottom: -46px;
							right: 0;
							animation: blMove2 3s infinite linear;
							opacity: 1;
						}
					}
				}
				
				.b{
					position: absolute;
					bottom: -40px;
					width: 120%;
				}
				.label{
					position: absolute;
					top: 110%;
					font-size: 12px;
				}
			}
		}

		.bottom {
			flex: 1;
			flex-direction: row;
			justify-content: space-around;
			align-items: stretch;
			padding: 0 20px;
			box-sizing: border-box;

			.itemK {
				flex: 1;
				justify-content: center;
				align-items: center;
				position: relative;

				.item {
					width: 100%;
					height: 100%;
					flex: 1;
				}
				.inner{
					font-size: 14px;
				}
				>span {
					position: absolute;
					transform: translateY(12px);
				}
				.values{
					position: absolute;
					width: 100%;
					height: 100%;
					font-size: 12px;
					font-weight: bold;
					// z-index: 9;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					div{
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						&:first-child{
							transform: translateX(-80px) translateY(10px);
						}
						&:last-child{
							transform: translateX(80px) translateY(20px);
						}
					}
				}
			}

			.item {
				flex: 1;

				&.progress {
					flex: 2;
					flex-direction: column;

					.title {
						flex-direction: row;
						justify-content: space-between;
						align-items: center;

						p {
							flex: 1;
							text-align: center;
							font-size: 14px;
							line-height: 36px;
							padding-right: 24px;
						}
					}

					.progressList {
						flex-direction: row;
						justify-content: space-between;
						align-items: center;
						flex-wrap: wrap;
						flex: 1;

						.progressItem {
							width: 50%;
							padding-right: 20px;

							span {
								font-size: 12px;
								line-height: 20px;
							}

							.progressInner {
								width: 100%;
								height: 8px;
								background: #2b516b;
							}


							@keyframes progressMove {
								0% {
									transform: scaleX(0);
								}

								100% {
									transform: scaleX(1);
								}
							}

							.progressView {
								height: 100%;
								transform-origin: left top;
								animation: progressMove 2s forwards;
							}

						}
					}
				}
			}
		}
	}
</style>